import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $failure, $requesting, $success } from '../form/action';
import { $processing } from 'services/activity/action';
import { $done } from 'services/activity/action';

export const MODULE = 'Pricing';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $create = ActionCreator.Async(MODULE, 'Create', (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/tms/pricing`, payload)
      .then((response) => {
        dispatch($create.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $get = ActionCreator.Async(MODULE, 'Get', (payload) => {
  return async (dispatch) => {
    dispatch($processing($get.OPERATION));

    return await Rest.GET(`${API_URL}/tms/pricing`, payload)
      .then((response) => {
        dispatch($get.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($get.OPERATION)));
  };
});

export const $show = ActionCreator.Async(MODULE, 'Show', (id) => {
  return async (dispatch) => {
    dispatch($processing($show.OPERATION));

    return await Rest.GET(`${API_URL}/tms/pricing/${id}`)
      .then((response) => {
        dispatch($show.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($show.OPERATION)));
  };
});

export const $update = ActionCreator.Async(MODULE, 'Update', (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/tms/pricing/${id}`, payload)
      .then((response) => {
        dispatch($update.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $delete = ActionCreator.Async(MODULE, 'Delete', (id) => {
  return async (dispatch) => {
    dispatch($processing($delete.OPERATION));

    return await Rest.DELETE(`${API_URL}/tms/pricing/${id}`)
      .then((response) => {
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($delete.OPERATION)));
  };
});

export const $createCustomer = ActionCreator.Async(
  MODULE,
  'Create.Customer',
  (payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.POST(`${API_URL}/tms/pricing/customer`, payload)
        .then((response) => {
          dispatch($createCustomer.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $getCustomer = ActionCreator.Async(
  MODULE,
  'Get.Customer',
  (payload, id) => {
    return async (dispatch) => {
      dispatch($processing($getCustomer.OPERATION));

      return await Rest.GET(`${API_URL}/tms/pricing/customer/${id}`, payload)
        .then((response) => {
          dispatch($getCustomer.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($getCustomer.OPERATION)));
    };
  }
);

export const $showCustomer = ActionCreator.Async(
  MODULE,
  'Show.Customer',
  (id) => {
    return async (dispatch) => {
      dispatch($processing($showCustomer.OPERATION));

      return await Rest.GET(`${API_URL}/tms/pricing/customer/show/${id}`)
        .then((response) => {
          dispatch($showCustomer.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($showCustomer.OPERATION)));
    };
  }
);

export const $updateCustomer = ActionCreator.Async(
  MODULE,
  'Update.Customer',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(`${API_URL}/tms/pricing/customer/${id}`, payload)
        .then((response) => {
          dispatch($updateCustomer.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $deleteCustomer = ActionCreator.Async(
  MODULE,
  'Delete.Customer',
  (id) => {
    return async (dispatch) => {
      dispatch($processing($deleteCustomer.OPERATION));

      return await Rest.DELETE(`${API_URL}/tms/pricing/customer/${id}`)
        .then((response) => {
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($deleteCustomer.OPERATION)));
    };
  }
);
